import styled from 'styled-components';

export const ValueContainer = styled.div<{ $valid: boolean }>`
  padding: 2.1rem 0.6rem 0.3333rem 1rem;
  border: solid 1px ${({ $valid, theme }) => ($valid ? theme.black.a1 : theme.red.a10)};
  background-color: ${({ $valid, theme }) => ($valid ? theme.white.a10 : theme.red.a1)};
  border-radius: 5px;
  box-shadow: none;
  min-height: 60px;
  font-size: 15px;
  letter-spacing: 0.25px;
  color: ${({ theme }) => theme.baseBlue.a10};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
